var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "incentive-fornew-root", class: { graymask: _vm.limited } },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { "left-arrow": "" },
            on: { "click-left": _vm.closeWeb },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow01.png"),
                        alt: "",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "incentive-fornew-head",
          style: { "margin-top": `-${_vm.barHeight + 46}px` },
        },
        [
          _c("div", { style: { height: `${_vm.barHeight + 46}px` } }),
          _c("div", { staticClass: "head-con" }, [
            _vm.$i18n.locale === "ar"
              ? _c("img", {
                  staticClass: "img-tit",
                  attrs: { src: require("./images/head-ar.png") },
                })
              : _vm.$i18n.locale === "es"
              ? _c("img", {
                  staticClass: "img-tit",
                  attrs: { src: require("./images/head-es.png") },
                })
              : _vm.$i18n.locale === "id"
              ? _c("img", {
                  staticClass: "img-tit",
                  attrs: { src: require("./images/head-id.png") },
                })
              : _vm.$i18n.locale === "pt"
              ? _c("img", {
                  staticClass: "img-tit",
                  attrs: { src: require("./images/head-pt.png") },
                })
              : _c("img", {
                  staticClass: "img-tit",
                  attrs: { src: require("./images/head-en.png") },
                }),
            _c("div", { staticClass: "deal-line" }, [
              _c("div", { staticClass: "timer" }, [
                _c("img", { attrs: { src: require("./images/clock.png") } }),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.countdownResult.hours) +
                      _vm._s(_vm.$t("lang.commonM.k364"))
                  ),
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.countdownResult.minutes) +
                      _vm._s(_vm.$t("lang.commonM.k365"))
                  ),
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.countdownResult.seconds) +
                      _vm._s(_vm.$t("lang.commonM.k366"))
                  ),
                ]),
              ]),
            ]),
            _c("img", {
              staticClass: "img-top",
              attrs: { src: _vm.getMatchTitle("top-img") },
            }),
          ]),
        ]
      ),
      _vm.actInfo
        ? _c("div", { staticClass: "incentive-fornew-con" }, [
            _c("div", { staticClass: "info-tit" }, [
              _c("div", { staticClass: "left" }),
              _c("div", { staticClass: "center" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k372"))),
              ]),
              _c("div", { staticClass: "right" }),
            ]),
            _vm.actInfo.milestones
              ? _c("div", { staticClass: "progress-block" }, [
                  _c("div", { staticClass: "progress-tips" }, [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k373"))),
                  ]),
                  _c("div", { staticClass: "progress-box" }, [
                    _c(
                      "div",
                      [
                        _vm.actInfo.milestones[0] &&
                        _vm.actInfo.milestones[0].rewardBeans > 0
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "box-top",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleClaim1(
                                        _vm.actInfo.milestones[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.actInfo.milestones[0].rewardBeans
                                        )
                                    ),
                                    _c("img", {
                                      attrs: { src: _vm.getMatchImg("beans") },
                                    }),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("./images/tips-arrow.png"),
                                    },
                                  }),
                                ]
                              ),
                              _vm.actInfo.milestones[0].ifClaimed
                                ? _c("img", {
                                    staticClass: "box",
                                    attrs: {
                                      src: require("./images/box-open.png"),
                                    },
                                  })
                                : _c("img", {
                                    staticClass: "box",
                                    class: {
                                      sharking:
                                        _vm.actInfo.milestones[0].ifCanClaim,
                                    },
                                    attrs: { src: require("./images/box.png") },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleClaim1(
                                          _vm.actInfo.milestones[0]
                                        )
                                      },
                                    },
                                  }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      [
                        _vm.actInfo.milestones[1]
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "box-top",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleClaim1(
                                        _vm.actInfo.milestones[1]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.actInfo.milestones[1].rewardBeans
                                        )
                                    ),
                                    _c("img", {
                                      attrs: { src: _vm.getMatchImg("beans") },
                                    }),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("./images/tips-arrow.png"),
                                    },
                                  }),
                                ]
                              ),
                              _vm.actInfo.milestones[1].ifClaimed
                                ? _c("img", {
                                    staticClass: "box",
                                    attrs: {
                                      src: require("./images/box-open.png"),
                                    },
                                  })
                                : _c("img", {
                                    staticClass: "box",
                                    class: {
                                      sharking:
                                        _vm.actInfo.milestones[1].ifCanClaim,
                                    },
                                    attrs: { src: require("./images/box.png") },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleClaim1(
                                          _vm.actInfo.milestones[1]
                                        )
                                      },
                                    },
                                  }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      [
                        _vm.actInfo.milestones[2]
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "box-top",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleClaim1(
                                        _vm.actInfo.milestones[2]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.actInfo.milestones[2].rewardBeans
                                        )
                                    ),
                                    _c("img", {
                                      attrs: { src: _vm.getMatchImg("beans") },
                                    }),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("./images/tips-arrow.png"),
                                    },
                                  }),
                                ]
                              ),
                              _vm.actInfo.milestones[2].ifClaimed
                                ? _c("img", {
                                    staticClass: "box",
                                    attrs: {
                                      src: require("./images/box-open.png"),
                                    },
                                  })
                                : _c("img", {
                                    staticClass: "box",
                                    class: {
                                      sharking:
                                        _vm.actInfo.milestones[2].ifCanClaim,
                                    },
                                    attrs: { src: require("./images/box.png") },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleClaim1(
                                          _vm.actInfo.milestones[2]
                                        )
                                      },
                                    },
                                  }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                  _c("div", { staticClass: "progress-wraper" }, [
                    _c(
                      "div",
                      { staticClass: "progress-bar" },
                      [
                        _c("div", {
                          staticClass: "step step0",
                          class: {
                            on:
                              _vm.actInfo.milestones[0] &&
                              _vm.actInfo.milestones[0].ifCanClaim,
                          },
                        }),
                        _c("div", {
                          staticClass: "step step1",
                          class: {
                            on:
                              _vm.actInfo.milestones[1] &&
                              _vm.actInfo.milestones[1].ifCanClaim,
                          },
                        }),
                        _vm.actInfo.ifShowOther
                          ? [
                              _c("div", { staticClass: "step step2" }),
                              _c("div", { staticClass: "step step3" }),
                              _c("div", { staticClass: "step step4" }),
                            ]
                          : _vm._e(),
                        _c("div", {
                          staticClass: "step step5",
                          class: {
                            on:
                              _vm.actInfo.milestones[2] &&
                              _vm.actInfo.milestones[2].ifCanClaim,
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "progress-trace",
                            style: { width: _vm.mePosition },
                          },
                          [
                            _vm.actInfo.earnBeans
                              ? _c("div", { staticClass: "me" })
                              : _vm._e(),
                          ]
                        ),
                      ],
                      2
                    ),
                  ]),
                  _c("div", { staticClass: "progress-beans" }, [
                    _c(
                      "div",
                      [
                        _vm.actInfo.milestones[0]
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.actInfo.milestones[0].requireBeans)
                              ),
                              _c("img", {
                                attrs: { src: _vm.getMatchImg("beans") },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      [
                        _vm.actInfo.milestones[1]
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.actInfo.milestones[1].requireBeans)
                              ),
                              _c("img", {
                                attrs: { src: _vm.getMatchImg("beans") },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      [
                        _vm.actInfo.milestones[2]
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.actInfo.milestones[2].requireBeans)
                              ),
                              _c("img", {
                                attrs: { src: _vm.getMatchImg("beans") },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _c("div", { staticClass: "incentive-fornew-con" }, [
        _c("div", { staticClass: "info-tit" }, [
          _c("div", { staticClass: "left" }),
          _c("div", { staticClass: "center" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k386"))),
          ]),
          _c("div", { staticClass: "right" }),
        ]),
        _c(
          "div",
          { staticClass: "task-block" },
          _vm._l(_vm.tasks, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "task-item",
                class: { "task-off": !item.ifFinish || item.ifClaimed },
              },
              [
                _c("div", { staticClass: "task-txt" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
                _c("div", { staticClass: "task-per" }, [
                  _vm._v(_vm._s(item.proc) + "/" + _vm._s(item.target)),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "task-btn",
                    on: {
                      click: function ($event) {
                        return _vm.handleClaim2(item)
                      },
                    },
                  },
                  [
                    item.ifClaimed === false
                      ? [
                          _vm._v(" +" + _vm._s(item.rewardBeans)),
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("beans") },
                          }),
                        ]
                      : _vm._e(),
                    [
                      item.ifClaimed === true
                        ? _c("img", {
                            attrs: { src: require("./images/check.png") },
                          })
                        : _vm._e(),
                    ],
                  ],
                  2
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "incentive-fornew-con" }, [
        _c("div", { staticClass: "info-tit" }, [
          _c("div", { staticClass: "left" }),
          _c("div", { staticClass: "center" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k111"))),
          ]),
          _c("div", { staticClass: "right" }),
        ]),
        _c("div", { staticClass: "rules" }, [
          _c(
            "div",
            [
              _c("MyPLabel", {
                staticClass: "dia-tips",
                attrs: { str: `1.${_vm.$t("lang.commonM.k374")}` },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("MyPLabel", {
                staticClass: "dia-tips",
                attrs: { str: `2.${_vm.$t("lang.commonM.k375")}` },
              }),
            ],
            1
          ),
          _c("div", [_vm._v("3." + _vm._s(_vm.$t("lang.commonM.k376")))]),
          _c("div", [_vm._v("4." + _vm._s(_vm.$t("lang.commonM.k377")))]),
        ]),
      ]),
      _c("div", { staticStyle: { height: "150px" } }),
      _vm.showReward
        ? _c("div", { staticClass: "mask" }, [
            _c("div", { staticClass: "dia-con" }, [
              _c("div", { staticClass: "reward-item" }, [
                _c("span", [_vm._v(_vm._s(_vm.reward))]),
                _c("img", {
                  attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                }),
              ]),
              _c("p", { staticClass: "dia-tips" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k378"))),
              ]),
              _c(
                "div",
                {
                  staticClass: "rules-btn",
                  on: {
                    click: function ($event) {
                      _vm.showReward = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("lang.ok")))]
              ),
            ]),
          ])
        : _vm._e(),
      _vm.limited
        ? _c("div", { staticClass: "mask" }, [
            _c(
              "div",
              { staticClass: "dia-con" },
              [
                _c("MyPLabel", {
                  staticClass: "dia-tips",
                  attrs: { str: _vm.$t("lang.commonM.k379") },
                }),
                _c(
                  "div",
                  { staticClass: "rules-btn", on: { click: _vm.closeWeb } },
                  [_vm._v(_vm._s(_vm.$t("lang.ok")))]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.showVerification
        ? _c("div", { staticClass: "mask" }, [
            _c("div", { staticClass: "dia-con" }, [
              _c("div", { staticClass: "dia-tit" }, [
                _vm._v(_vm._s(_vm.$t("lang.inviteHostNew.verification"))),
              ]),
              _c("p", { staticClass: "dia-tips" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k115"))),
              ]),
              _c("div", { staticClass: "btn-block" }, [
                _c(
                  "div",
                  {
                    staticClass: "rules-btn close",
                    on: { click: _vm.closeWeb },
                  },
                  [_vm._v(_vm._s(_vm.$t("lang.intimate.close")))]
                ),
                _c("div", { staticClass: "rules-btn-gap" }),
                _c(
                  "div",
                  { staticClass: "rules-btn", on: { click: _vm.toVerify } },
                  [_vm._v(_vm._s(_vm.$t("lang.commonM.k116")))]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }